(function() {
  class ZalifyCountdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        this._run();
      }, 100);
    }
    _transformNumber(number) {
      return number > 9 ? `${number}` : `${0}${number}`;
    }
    _run() {
      const timeEl = this.querySelector('.time');
     
      const { endDate } = this.dataset;
      var endTime = new Date(endDate).getTime();
      if (isNaN(endTime)) {
        return;
      }
      var timeLeft = Math.floor((endTime - Date.now()) / 1000);
      if (timeLeft > 0) {
        var secs = this._transformNumber(timeLeft % 60);
        var mins = this._transformNumber(Math.floor(timeLeft / 60) % 60);
        var hours = this._transformNumber(
          Math.floor(timeLeft / (60 * 60)) % 24,
        );
        var days = this._transformNumber(Math.floor(timeLeft / (60 * 60 * 24)));
        const daysEl = timeEl.querySelector('.countdown-days .cd-number');
        const hoursEl = timeEl.querySelector('.countdown-hours .cd-number');
        const minsEl = timeEl.querySelector('.countdown-min .cd-number');
        const secsEl = timeEl.querySelector('.countdown-sec .cd-number');
        if (daysEl.innerHTML !== days) {
          daysEl.innerHTML = days;
        }
        if (hoursEl.innerHTML !== hours) {
          hoursEl.innerHTML = hours;
        }
        if (minsEl.innerHTML !== mins) {
          minsEl.innerHTML = mins;
        }
        if (secsEl.innerHTML !== secs) {
          secsEl.innerHTML = secs;
        }
        setTimeout(() => this._run(), 1000);
        timeEl.classList.add("t4s-countdown-enabled");
      } else {
        timeEl.classList.remove("t4s-countdown-enabled");
      }
    }
  };
  window.customElements.define("zalify-countdown", ZalifyCountdown);
})();
